import UtilsTypes from './utils.types';

export const setErrorPanel = (obj) => ({
	type: UtilsTypes.SET_ERROR_PANEL,
	payload: obj,
});

export const setAlertMsg = (text) => ({
	type: UtilsTypes.SET_ALERT_MSG,
	payload: text,
});

export const setRedirectURL = (obj) => ({
	type: UtilsTypes.SET_REDIRECT_URL,
	payload: obj,
});

export const testMicRecording = (val) => ({
	type: UtilsTypes.MIC_TEST_RECORDING.PENDING,
	payload: val,
});

export const handleBlobChange = ({ blob, index }) => ({
	type: UtilsTypes.HANDLE_BLOB_CHANGE,
	payload: { blob, index },
});

export const onClickRecord = (obj) => ({
	type: UtilsTypes.ON_CLICK_REC,
	payload: obj,
});

export const showInstructionVal = (val) => ({
	type: UtilsTypes.SHOW_INSTRUCTION,
	payload: val,
});

export const setResetCounter = (val) => ({
	type: UtilsTypes.UPDATE_RESET_COUNTER,
	payload: val,
});

export const handleVideoBlobChange = (blob) => ({
	type: UtilsTypes.HANDLE_VIDEO_BLOB_CHANGE,
	payload: blob,
});

export const setErrorMsg = (text) => ({
	type: UtilsTypes.SET_ERROR_MSG,
	payload: text,
});

export const setSpeechStatus = () => ({
	type: UtilsTypes.POST_SPEECH_STATUS.PENDING,
});

export const setShowError = (val) => ({
	type: UtilsTypes.SHOW_ERROR,
	payload: val,
});

export const setShowEcho = (val) => ({
	type: UtilsTypes.SHOW_ECHO,
	payload: val,
});
export const setShowPermitMic = (val) => ({
	type: UtilsTypes.SHOW_PERMIT_MIC,
	payload: val,
});
export const setShowConfirmName = (val) => ({
	type: UtilsTypes.SHOW_CONFIRM_NAME,
	payload: val,
});

export const resetAudioBlob = () => ({
	type: UtilsTypes.RESET_AUDIO_BLOB,
});